import styled from '@emotion/styled';
import {
  gray01,
  gray02,
  gray03,
  gray04,
  primary,
} from 'presentations/views/styles/color';
import { SyntheticEvent, memo, useContext, useMemo } from 'react';
import Icon from 'presentations/views/components/atoms/Icon';
import { CalendarContext } from 'presentations/views/components/atoms/Calendar/reducer/CalendarContext';
import { horizontalRulerWidth } from '../reducer';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import { getDateTime } from 'infras/datetime';

interface Props {
  onClickAddTimeZone?: (el: HTMLElement) => void;
  onClickTimeZone?: (timeZone: string, el: HTMLElement) => void;
}

const Component = memo((props: Props) => {
  const { state } = useContext(CalendarContext);
  const curentTimeZoneName = getDateTime().setZone(state.timeZone)
    .offsetNameShort;
  const timeZones = useMemo(() => {
    return state.rulerTimeZones.map((timeZone) => {
      return getDateTime().setZone(timeZone).toFormat('Z');
    });
  }, [state.rulerTimeZones]);

  const onClickAddTimeZone = (e: SyntheticEvent<HTMLDivElement>) => {
    if (!props.onClickAddTimeZone) return;
    props.onClickAddTimeZone(e.currentTarget);
  };

  const onClickTimeZone = (e: SyntheticEvent<HTMLDivElement>) => {
    if (!props.onClickTimeZone) return;
    const { id } = e.currentTarget.dataset;
    if (!id) return;
    const index = Number(id);
    const timeZone = state.rulerTimeZones[index];
    props.onClickTimeZone(timeZone, e.currentTarget);
  };

  const onClickCurrentTimeZone = (e: SyntheticEvent<HTMLDivElement>) => {
    // if (!props.onClickTimeZone) return;
    // props.onClickTimeZone(state.timeZone, e.currentTarget);
  };

  return (
    <RulerList>
      <Ruler width={horizontalRulerWidth}>
        <CurrentRulerCell onClick={onClickCurrentTimeZone}>
          {curentTimeZoneName}
        </CurrentRulerCell>
      </Ruler>
      {!state.isDisableMultiTimeZones &&
        timeZones.map((timeZone, index) => (
          <Ruler key={timeZone} width={horizontalRulerWidth}>
            <RulerCell data-id={index} onClick={onClickTimeZone}>
              GMT
              <br />
              {timeZone}
            </RulerCell>
          </Ruler>
        ))}
      {!state.isDisableMultiTimeZones && props.onClickAddTimeZone && (
        <AddButton onClick={onClickAddTimeZone}>
          <StyledIcon name="plus" />
        </AddButton>
      )}
    </RulerList>
  );
});

const RulerList = styled.div`
  display: flex;
  position: relative;
`;
const AddButton = styled.div`
  position: absolute;
  right: -10px;
  top: calc(50% - 8px);
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: ${spacing(2)};
  width: 16px;
  height: 16px;
  border: 1px dotted ${gray03};
  border-radius: 50%;
  :hover {
    border: 1px dotted ${primary};
  }
`;
const StyledIcon = styled(Icon)`
  width: 14px !important;
  height: 14px !important;
  color: ${gray02};
  user-select: none;
  pointer-events: none;
  :hover {
    color: ${primary};
  }
`;
const Ruler = styled.div<{ width: number }>`
  width: ${(props) => `${props.width}px`};
  border-bottom: 1px solid ${gray04};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${gray02};
  padding-right: ${spacing(2)};
`;
const RulerCell = styled.div<{ height?: number }>`
  cursor: pointer;
  font-size: ${fontSize(10)};
  font-weight: ${fontWeight('bold')};
  letter-spacing: -0.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1;
`;
const CurrentRulerCell = styled(RulerCell)`
  cursor: initial;
`;

export default Component;
